<template>
    <div class="p-pt-1 p-ai-center p-grid p-jc-center">
        <div
                class=" p-col  "
        >
            <Dropdown
                    optionLabel="displayName"
                    style="text-align: center; width:100%"
                    v-model="selectedReportName"
                    :options="reportRanges"
                    placeholder="בחר תעודה"
                    @input="updateReportName"
            >

            </Dropdown>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";

export default {
    name: "SelectBar",
    data() {
        return {
            componentKey: 0,
            selectedReportName: null,
        }
    },
    mounted() {
        this.selectedReportName = Vue.ls.get('menage_selectedReportName') || this.reportRanges[0]
    },
    watch: {
        selectedReportName(newValue, oldValue) {
                Vue.ls.set('menage_selectedReportName', newValue);
            if (newValue?.id !== oldValue?.id){
                this.updateReportName()
            }
        }
    },
    methods: {
        updateReportName() {
            this.$emit("updateReportName", this.selectedReportName)
        },

    },
    computed: {
        ...mapState(["reportRanges", "intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",
            "subjectTracing"]),
    }
}
</script>

<style scoped>

</style>